import {
  Box,
  Button,
  InputLabel,
  MenuItem,
  Popover,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as FileImport } from "../../../../../assets/AccountingModule/uil_file_import.svg";
import Modal from "../../../../../components/Modal";
import SubHeader from "../../../../../components/SubHeader";
import color from "../../../../../constants/color";
import AllTransactionList from "./AllTransactionList";
import style from "./style";
import UncategorizedTransactionList from "./UncategorizedTransactionList";
import dayjs from "dayjs";
import { useAlert } from "../../../../../context/AlertContext";
import utc from "dayjs/plugin/utc";
import { depositsFromOtherFromAccountOptions, expenseAccountOptions, expenseRefundFromAccountOptions, otherIncomeFromAccountOptions, ownersContributionFromAccountOptions, ownersDrawingToAccountOptions, paidViaOptions, TDSOptions, transferFromAccountOptions, transferToAccountOptions } from "../../../../../constants/data";
dayjs.extend(utc);

function AccountTransactionPage({
  transactionData,
  uncategorizedTransactionData,
  pageAll,
  setPageAll,
  totalAll,
  pageUncategorized,
  setPageUncategorized,
  totalUncategorized,
  handleFilter,
  customers,
  vendors,
  handleAddTransaction,
  accountID,
  bankName,
  handleUpdateUncategorizedTransactions,
  refreshTransactions,
  accountType,
  showStatementButton,
}) {
  const navigate = useNavigate();
  const theme = useTheme();
  const [openAddTransactionModal, setOpenAddTransactionModal] = useState(false);
  const [vendor, setVendor] = useState("");
  const [customer, setCustomer] = useState("");
  const [amount, setAmount] = useState("");
  const [tds, setTds] = useState("");
  const [date, setDate] = useState(dayjs());
  const [reference, setReference] = useState("");
  const [description, setDescription] = useState("");
  const [paidVia, setPaidVia] = useState("");
  const [depositTo, setDepositTo] = useState("");
  const [activeTab, setActiveTab] = useState("all");
  const [transactionType, setTransactionType] = useState("");

  const [anchorEl, setAnchorEl] = useState(null);

  const [moneyInOptionsPopover, setMoneyInOptionsPopover] = useState(false);
  const [moneyOutOptionsPopover, setMoneyOutOptionsPopover] = useState(false);

  // State for individual option modals
  const [openCustomerAdvanceModal, setOpenCustomerAdvanceModal] = useState(false);
  const [openCustomerPaymentModal, setOpenCustomerPaymentModal] = useState(false);
  const [openTransferFromAccountModal, setOpenTransferFromAccountModal] = useState(false);
  const [openInterestIncomeModal, setOpenInterestIncomeModal] = useState(false);
  const [openOtherIncomeModal, setOpenOtherIncomeModal] = useState(false);
  const [openExpenseRefundModal, setOpenExpenseRefundModal] = useState(false);
  const [openDepositsFromAccountsModal, setOpenDepositsFromAccountsModal] = useState(false);
  const [openOwnersContributionModal, setOpenOwnersContributionModal] = useState(false);
  const [openVendorCreditRefundModal, setOpenVendorCreditRefundModal] = useState(false);
  const [openVendorPaymentRefundModal, setOpenVendorPaymentRefundModal] = useState(false);
  const [openExpenseModal, setOpenExpenseModal] = useState(false);
  const [openVendorAdvanceModal, setOpenVendorAdvanceModal] = useState(false);
  const [openVendorPaymentModal, setOpenVendorPaymentModal] = useState(false);
  const [openTransferToAccountModal, setOpenTransferToAccountModal] = useState(false);
  const [openOwnerDrawingsModal, setOpenOwnerDrawingsModal] = useState(false);
  const [openCreditNoteRefundModal, setOpenCreditNoteRefundModal] = useState(false);
  const [openPaymentRefundModal, setOpenPaymentRefundModal] = useState(false);

  // Form state for each modal
  const [customerAdvanceData, setCustomerAdvanceData] = useState({
    customer: "",
    paidVia: "",
    TDS: "",
    amount: "",
    date: dayjs(),
    reference: "",
    description: "",
    labelName: "Customer Advance",
  });

  const [customerPaymentData, setCustomerPaymentData] = useState({
    customer: "",
    paidVia: "",
    TDS: "",
    amount: "",
    date: dayjs(),
    reference: "",
    description: "",
    labelName: "Customer Payment",
  });

  const [transferFromAccountData, setTransferFromAccountData] = useState({
    fromAccount: "",
    amount: "",
    date: dayjs(),
    reference: "",
    description: "",
    labelName: "Transfer from Another Account"
  });

  const [interestIncomeData, setInterestIncomeData] = useState({
    amount: "",
    date: dayjs(),
    reference: "",
    description: "",
    paidVia: "",
    labelName: "Interest Income",
  });

  const [otherIncomeData, setOtherIncomeData] = useState({
    amount: "",
    date: dayjs(),
    reference: "",
    description: "",
    fromAccount: "",
    labelName: "Other Income",
  });

  const [expenseRefundData, setExpenseRefundData] = useState({
    vendor: "",
    amount: "",
    date: dayjs(),
    reference: "",
    description: "",
    fromAccount: "",
    labelName: "Expense Refund",
  });

  const [depositsFromAccountsData, setDepositsFromAccountsData] = useState({
    fromAccount: "",
    amount: "",
    date: dayjs(),
    reference: "",
    description: "",
    labelName: "Deposits from Other Accounts"
  });

  const [ownersContributionData, setOwnersContributionData] = useState({
    owner: "",
    amount: "",
    date: dayjs(),
    reference: "",
    description: "",
    contributionType: "",
    labelName: "Owners Contribution",
  });

  const [vendorCreditRefundData, setVendorCreditRefundData] = useState({
    vendor: "",
    amount: "",
    date: dayjs(),
    reference: "",
    description: "",
    labelName: "Vendor Credit Refund",
  });

  const [vendorPaymentRefundData, setVendorPaymentRefundData] = useState({
    vendor: "",
    amount: "",
    date: dayjs(),
    reference: "",
    description: "",
    labelName: "Vendor Payment Refund"
  });

  const [expenseData, setExpenseData] = useState({
    vendor: "",
    customer: "",
    amount: "",
    date: dayjs(),
    reference: "",
    description: "",
    toAccount: "",
    labelName: "Expense",
  });

  const [vendorAdvanceData, setVendorAdvanceData] = useState({
    vendor: "",
    amount: "",
    date: dayjs(),
    reference: "",
    description: "",
    labelName: "Vendor Advance"
  });

  const [vendorPaymentData, setVendorPaymentData] = useState({
    vendor: "",
    amount: "",
    date: dayjs(),
    reference: "",
    description: "",
    paidVia: "",
    TDS: "",
    labelName: "Vendor Payment"
  });

  const [transferToAccountData, setTransferToAccountData] = useState({
    toAccount: "",
    amount: "",
    date: dayjs(),
    reference: "",
    description: "",
    labelName: "Transfer to Another Account"
  });

  const [ownerDrawingsData, setOwnerDrawingsData] = useState({
    amount: "",
    date: dayjs(),
    reference: "",
    description: "",
    toAccount: "",
    labelName: "Owner Drawings"
  });

  const [creditNoteRefundData, setCreditNoteRefundData] = useState({
    customer: "",
    amount: "",
    date: dayjs(),
    reference: "",
    description: "",
    labelName: "Credit Note Refund",
  });

  const [paymentRefundData, setPaymentRefundData] = useState({
    customer: "",
    amount: "",
    date: dayjs(),
    reference: "",
    description: "",
    labelName: "Payment Refund",
  });

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setMoneyInOptionsPopover(false);
    setMoneyOutOptionsPopover(false);
  };

  const handleOpenPopup = (labelName) => {
    handlePopoverClose();

    // Open the corresponding modal based on the option
    switch (labelName) {
      case "customerAdvance":
        setOpenCustomerAdvanceModal(true);
        break;
      case "customerPayment":
        setOpenCustomerPaymentModal(true);
        break;
      case "transferFromAnotherAccount":
        setOpenTransferFromAccountModal(true);
        break;
      case "interestIncome":
        setOpenInterestIncomeModal(true);
        break;
      case "otherIncome":
        setOpenOtherIncomeModal(true);
        break;
      case "expenseRefund":
        setOpenExpenseRefundModal(true);
        break;
      case "depositsFromOtherAccounts":
        setOpenDepositsFromAccountsModal(true);
        break;
      case "ownersContribution":
        setOpenOwnersContributionModal(true);
        break;
      case "vendorCreditRefund":
        setOpenVendorCreditRefundModal(true);
        break;
      case "vendorPaymentRefund":
        setOpenVendorPaymentRefundModal(true);
        break;
      case "expense":
        setOpenExpenseModal(true);
        break;
      case "vendorAdvance":
        setOpenVendorAdvanceModal(true);
        break;
      case "vendorPayment":
        setOpenVendorPaymentModal(true);
        break;
      case "transferToAnotherAccount":
        setOpenTransferToAccountModal(true);
        break;
      case "ownerDrawings":
        setOpenOwnerDrawingsModal(true);
        break;
      case "creditNoteRefund":
        setOpenCreditNoteRefundModal(true);
        break;
      case "paymentRefund":
        setOpenPaymentRefundModal(true);
        break;
      default:
        break;
    }
  };

  // Reconcile modal state
  const { showAlert } = useAlert();

  const handleTabChange = (tab) => setActiveTab(tab);
  const handleNavigate = (path, state) => navigate(path, { state });

  // Add reset function
  const resetForm = () => {
    setVendor("");
    setCustomer("");
    setAmount("");
    setTds("");
    setDate(dayjs());
    setReference("");
    setDescription("");
    setPaidVia("");
    setDepositTo("");
    setTransactionType("");
  };

  // Add modal close handler
  const handleModalClose = () => {
    resetForm();
    setOpenAddTransactionModal(false);
  };

  // Reset functions for each modal
  const resetCustomerAdvance = () => {
    setCustomerAdvanceData({
      customer: "",
      amount: "",
      date: dayjs(),
      reference: "",
      description: "",
      paidVia: "",
      TDS: "",
      labelName: "Customer Advance",
    });
  };

  const resetCustomerPayment = () => {
    setCustomerPaymentData({
      customer: "",
      amount: "",
      date: dayjs(),
      reference: "",
      description: "",
      paidVia: "",
      TDS: "",
      labelName: "Customer Payment",
    });
  };

  const resetTransferFromAccount = () => {
    setTransferFromAccountData({
      fromAccount: "",
      amount: "",
      date: dayjs(),
      reference: "",
      description: "",
      labelName: "Transfer from Another Account"
    });
  };

  const resetInterestIncome = () => {
    setInterestIncomeData({
      amount: "",
      date: dayjs(),
      reference: "",
      description: "",
      paidVia: "",
      labelName: "Interest Income",
    });
  };

  const resetOtherIncome = () => {
    setOtherIncomeData({
      amount: "",
      date: dayjs(),
      reference: "",
      description: "",
      fromAccount: "",
      labelName: "Other Income",
    });
  };

  const resetExpenseRefund = () => {
    setExpenseRefundData({
      vendor: "",
      amount: "",
      date: dayjs(),
      reference: "",
      description: "",
      fromAccount: "",
      labelName: "Expense Refund",
    });
  };

  const resetDepositsFromAccounts = () => {
    setDepositsFromAccountsData({
      fromAccount: "",
      amount: "",
      date: dayjs(),
      reference: "",
      description: "",
      labelName: "Deposits from Other Accounts"
    });
  };

  const resetOwnersContribution = () => {
    setOwnersContributionData({
      owner: "",
      amount: "",
      date: dayjs(),
      reference: "",
      description: "",
      contributionType: "",
      labelName: "Owners Contribution",
    });
  };

  const resetVendorCreditRefund = () => {
    setVendorCreditRefundData({
      vendor: "",
      amount: "",
      date: dayjs(),
      reference: "",
      description: "",
      labelName: "Vendor Credit Refund",
    });
  };

  const resetVendorPaymentRefund = () => {
    setVendorPaymentRefundData({
      vendor: "",
      amount: "",
      date: dayjs(),
      reference: "",
      description: "",
      labelName: "Vendor Payment Refund"
    });
  };

  const resetExpense = () => {
    setExpenseData({
      vendor: "",
      customer: "",
      amount: "",
      date: dayjs(),
      reference: "",
      description: "",
      toAccount: "",
      labelName: "Expense",
    });
  };

  const resetVendorAdvance = () => {
    setVendorAdvanceData({
      vendor: "",
      amount: "",
      date: dayjs(),
      reference: "",
      description: "",
      labelName: "Vendor Advance"
    });
  };

  const resetVendorPayment = () => {
    setVendorPaymentData({
      vendor: "",
      amount: "",
      date: dayjs(),
      reference: "",
      description: "",
      paidVia: "",
      TDS: "",
      labelName: "Vendor Payment"
    });
  };

  const resetTransferToAccount = () => {
    setTransferToAccountData({
      toAccount: "",
      amount: "",
      date: dayjs(),
      reference: "",
      description: "",
      labelName: "Transfer to Another Account"
    });
  };

  const resetOwnerDrawings = () => {
    setOwnerDrawingsData({
      amount: "",
      date: dayjs(),
      reference: "",
      description: "",
      toAccount: "",
      labelName: "Owner Drawings"
    });
  };

  const resetCreditNoteRefund = () => {
    setCreditNoteRefundData({
      customer: "",
      amount: "",
      date: dayjs(),
      reference: "",
      description: "",
      labelName: "Credit Note Refund",
    });
  };

  const resetPaymentRefund = () => {
    setPaymentRefundData({
      customer: "",
      amount: "",
      date: dayjs(),
      reference: "",
      description: "",
      labelName: "Payment Refund"
    });
  };

  // Submit handlers for each modal
  const handleCustomerAdvanceSubmit = () => {
    // Add your submission logic here

    handleSubmitTransaction(customerAdvanceData);
    resetCustomerAdvance();
    setOpenCustomerAdvanceModal(false);
  };

  const handleCustomerPaymentSubmit = () => {
    // Add your submission logic here
    handleSubmitTransaction(customerPaymentData);
    resetCustomerPayment();
    setOpenCustomerPaymentModal(false);
  };

  const handleTransferFromAccountSubmit = () => {
    // Add your submission logic here
    handleSubmitTransaction(transferFromAccountData);
    resetTransferFromAccount();
    setOpenTransferFromAccountModal(false);
  };

  const handleInterestIncomeSubmit = () => {
    // Add your submission logic here
    handleSubmitTransaction(interestIncomeData);
    resetInterestIncome();
    setOpenInterestIncomeModal(false);
  };

  const handleOtherIncomeSubmit = () => {
    // Add your submission logic here
    handleSubmitTransaction(otherIncomeData);
    resetOtherIncome();
    setOpenOtherIncomeModal(false);
  };

  const handleExpenseRefundSubmit = () => {
    // Add your submission logic here
    handleSubmitTransaction(expenseRefundData);
    resetExpenseRefund();
    setOpenExpenseRefundModal(false);
  };

  const handleDepositsFromAccountsSubmit = () => {
    // Add your submission logic here
    handleSubmitTransaction(depositsFromAccountsData);
    resetDepositsFromAccounts();
    setOpenDepositsFromAccountsModal(false);
  };

  const handleOwnersContributionSubmit = () => {
    // Add your submission logic here
    handleSubmitTransaction(ownersContributionData);
    resetOwnersContribution();
    setOpenOwnersContributionModal(false);
  };

  const handleVendorCreditRefundSubmit = () => {
    // Add your submission logic here
    handleSubmitTransaction(vendorCreditRefundData);
    resetVendorCreditRefund();
    setOpenVendorCreditRefundModal(false);
  };

  const handleVendorPaymentRefundSubmit = () => {
    // Add your submission logic here
    handleSubmitTransaction(vendorPaymentRefundData);
    resetVendorPaymentRefund();
    setOpenVendorPaymentRefundModal(false);
  };

  const handleExpenseSubmit = () => {
    // Add your submission logic here
    handleSubmitTransaction(expenseData);
    resetExpense();
    setOpenExpenseModal(false);
  };

  const handleVendorAdvanceSubmit = () => {
    // Add your submission logic here
    handleSubmitTransaction(vendorAdvanceData);
    resetVendorAdvance();
    setOpenVendorAdvanceModal(false);
  };

  const handleVendorPaymentSubmit = () => {
    // Add your submission logic here
    handleSubmitTransaction(vendorPaymentData);
    resetVendorPayment();
    setOpenVendorPaymentModal(false);
  };

  const handleTransferToAccountSubmit = () => {
    // Add your submission logic here
    handleSubmitTransaction(transferToAccountData);
    resetTransferToAccount();
    setOpenTransferToAccountModal(false);
  };

  const handleOwnerDrawingsSubmit = () => {
    // Add your submission logic here
    handleSubmitTransaction(ownerDrawingsData);
    resetOwnerDrawings();
    setOpenOwnerDrawingsModal(false);
  };

  const handleCreditNoteRefundSubmit = () => {
    // Add your submission logic here
    handleSubmitTransaction(creditNoteRefundData);
    resetCreditNoteRefund();
    setOpenCreditNoteRefundModal(false);
  };

  const handlePaymentRefundSubmit = () => {
    // Add your submission logic here
    handleSubmitTransaction(paymentRefundData);
    // resetPaymentRefund();
    // setOpenPaymentRefundModal(false);
  };

  const tabSx = (tab) => ({
    fontWeight: 600,
    px: 2,
    pb: 1,
    cursor: "pointer",
    color: activeTab === tab ? color.primary : theme.palette.text.primary,
    borderBottom: `3px solid ${
      activeTab === tab ? color.primary : "transparent"
    }`,
    transition: "all 0.2s ease",
  });

  const handleSubmitTransaction = async (item) => {
    const numericAmount = parseFloat(item.amount);
    if (isNaN(numericAmount) || numericAmount <= 0) {
      showAlert("Please enter a valid amount greater than zero.", "warning");
      return;
    }
    const transactionDataToSend = {
      account: accountID,
      date: item.date.toISOString(),
      description: item.description,
      status: "Added Manually",
      paidVia: item?.paidVia,
      deposit: transactionType === "moneyIn" ? item?.amount : "",
      withdrawal: transactionType === "moneyOut" ? item?.amount : "",
      reference: item?.reference,
      tds: item?.TDS,
      transactionType: accountType,
      labelType: transactionType === "moneyIn" ? "MoneyIn" : "MoneyOut",
      labelName: item?.labelName,
      accountType: transactionType === "moneyIn" ?  item?.fromAccount : item?.toAccount
    };

    if (transactionType === "moneyOut") {
      transactionDataToSend.vendor = item?.vendor;
    } else if (transactionType === "moneyIn") {
      transactionDataToSend.customer = item?.customer;
    }

    if (
      item?.labelName === "Expense Refund" ||
      item?.labelName === "Vendor Credit Refund" ||
      item?.labelName === "Vendor Payment Refund"
    ) {
      transactionDataToSend.vendor = item?.vendor;
    } 
    else if (
      item?.labelName === "Expense"
    ) {
      transactionDataToSend.vendor = item?.vendor;
      transactionDataToSend.customer = item?.customer;
    } 
    else if (
      item?.labelName === "Credit Note Refund" ||
      item?.labelName === "Payment Refund"
    ) {
      transactionDataToSend.customer = item?.customer;
    }

    await handleAddTransaction(transactionDataToSend);
  };

  return (
    <>
      <Box
        px="15px"
        pt="20px"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h5" sx={style.heading}>
          {bankName}
        </Typography>

        <Box display="flex" gap={2}>
          <Button
            variant="contained"
            color="success"
            sx={style.importStatementBtn}
            onClick={(event) => {
              setTransactionType("moneyIn");
              setAnchorEl(event.currentTarget);
              setMoneyInOptionsPopover(true);
            }}
          >
            <FileImport /> Money In
          </Button>
          <Button
            variant="contained"
            color="success"
            sx={style.importStatementBtn}
            onClick={(event) => {
              setTransactionType("moneyOut");
              setAnchorEl(event.currentTarget);
              setMoneyOutOptionsPopover(true);
            }}
          >
            <FileImport /> Money Out
          </Button>
          {showStatementButton && (
            <Button
              variant="contained"
              color="success"
              sx={style.importStatementBtn}
              onClick={() =>
                handleNavigate("/dashboard/importStatement", {
                  bankName,
                  accountID,
                })
              }
            >
              Import Statement
            </Button>
          )}
          <Button
            variant="contained"
            color="success"
            sx={style.checkinBtn}
            onClick={() => {
              handleNavigate("/dashboard/accountReconciliationList", {
                bankName,
                accountID,
              });
            }}
          >
            Reconcile Account
          </Button>
        </Box>
      </Box>

      <Box sx={{ backgroundColor: color.card, m: 2, borderRadius: "20px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            p: "18px",
          }}
        >
          <Box sx={{ display: "flex", gap: "10px" }}>
            <Box sx={tabSx("all")} onClick={() => handleTabChange("all")}>
              All Transactions
            </Box>
            <Box
              sx={tabSx("uncategorised")}
              onClick={() => handleTabChange("uncategorised")}
            >
              Uncategorised Transactions
            </Box>
          </Box>

          <SubHeader
            search
            sortBy
            onchange={(e) => handleFilter(e)}
            handleSort={(e) => handleFilter("", e)}
          />
        </Box>

        {activeTab === "all" ? (
          <AllTransactionList
            data={transactionData}
            setPage={setPageAll}
            page={pageAll}
            total={totalAll}
            vendors={vendors}
            customers={customers}
          />
        ) : (
          <UncategorizedTransactionList
            data={uncategorizedTransactionData}
            setPage={setPageUncategorized}
            page={pageUncategorized}
            total={totalUncategorized}
            handleUpdateUncategorizedTransactions={
              handleUpdateUncategorizedTransactions
            }
            vendors={vendors}
            customers={customers}
            refreshTransactions={refreshTransactions}
          />
        )}
      </Box>

      {/* Original Add Transaction Modal */}
      <Modal
        open={openAddTransactionModal}
        setOpen={handleModalClose}
        disabled={
          !(vendor || customer) ||
          !amount ||
          !tds ||
          !date ||
          !reference ||
          !paidVia ||
          !description
        }
        btnText={"Save"}
        title={"Add Transaction"}
        handleCheck={handleSubmitTransaction}
      >
        <Box sx={style.modalGrid}>
          {transactionType === "moneyIn" && (
            <Box sx={{ width: "50%", ml: "5px" }}>
              <InputLabel sx={style.label}>Customer</InputLabel>
              <TextField
                select
                name="customer"
                value={customer || ""}
                onChange={(e) => setCustomer(e.target.value)}
                style={style.boxs2}
              >
                <MenuItem value="" disabled>
                  select
                </MenuItem>
                {customers.map((customer) => (
                  <MenuItem key={customer._id} value={customer._id}>
                    {customer.name}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          )}
          {transactionType === "moneyOut" && (
            <Box sx={{ width: "50%", ml: "5px" }}>
              <InputLabel sx={style.label}>Vendor</InputLabel>
              <TextField
                select
                name="vendor"
                value={vendor || ""}
                onChange={(e) => setVendor(e.target.value)}
                style={style.boxs2}
              >
                <MenuItem value="" disabled>
                  select
                </MenuItem>
                {vendors.map((vendor) => (
                  <MenuItem key={vendor._id} value={vendor._id}>
                    {vendor.name}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
          )}
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Paid Via</InputLabel>
            <TextField
              select
              name="paidVia"
              value={paidVia}
              onChange={(e) => setPaidVia(e.target.value)}
              sx={style.boxs2}
            >
              <MenuItem value="Bank Remittance">Bank Remittance</MenuItem>
              <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
              <MenuItem value="Cheque">Cheque</MenuItem>
              <MenuItem value="Credit Card">Credit Card</MenuItem>
              <MenuItem value="UPI">UPI</MenuItem>
            </TextField>
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Amount</InputLabel>
            <TextField
              name="amount"
              value={amount}
              type="number"
              required
              onChange={(e) => {
                setAmount(e.target.value);
              }}
              sx={style.boxs2}
            />
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>TDS</InputLabel>
            <TextField
              select
              name="tds"
              value={tds}
              onChange={(e) => setTds(e.target.value)}
              sx={style.boxs2}
            >
              <MenuItem value="TDS 1">TDS 1</MenuItem>
              <MenuItem value="TDS 2">TDS 2</MenuItem>
            </TextField>
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>Date</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box>
                <DatePicker
                  value={date}
                  slotProps={{
                    field: {
                      readOnly: true,
                    },
                  }}
                  sx={style.calenderInput}
                  onChange={(newValue) => {
                    setDate(newValue);
                  }}
                />
              </Box>
            </LocalizationProvider>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Reference#</InputLabel>
            <TextField
              name="reference"
              value={reference}
              type="text"
              required
              onChange={(e) => {
                setReference(e.target.value);
              }}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "100%", ml: "5px" }}>
            <InputLabel sx={style.label}>Description</InputLabel>
            <TextField
              name="desc"
              value={description}
              required
              onChange={(e) => {
                setDescription(e.target.value);
              }}
              sx={style.boxs2}
              multiline
              rows={2}
            />
          </Box>
        </Box>
      </Modal>

      {/* MONEY IN OPTION MODALS */}

      {/* Customer Advance Modal */}
      <Modal
        open={openCustomerAdvanceModal}
        setOpen={() => {
          resetCustomerAdvance();
          setOpenCustomerAdvanceModal(false);
        }}
        disabled={
          !customerAdvanceData.customer ||
          !customerAdvanceData.paidVia ||
          !customerAdvanceData.TDS ||
          !customerAdvanceData.amount ||
          !customerAdvanceData.date
        }
        btnText={"Submit"}
        title={"Customer Advance"}
        handleCheck={handleCustomerAdvanceSubmit}
      >
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Customer<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              select
              value={customerAdvanceData.customer}
              onChange={(e) =>
                setCustomerAdvanceData({
                  ...customerAdvanceData,
                  customer: e.target.value,
                })
              }
              placeholder="Select Customer"
              sx={style.boxs2}
            >
              <MenuItem value="" disabled>
                Select Customer
              </MenuItem>
              {customers.map((customer) => (
                <MenuItem key={customer._id} value={customer._id}>
                  {customer.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Amount<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              type="number"
              value={customerAdvanceData.amount}
              onChange={(e) => {
                const value = e.target.value < 0 ? "" : e.target.value;
                setCustomerAdvanceData({
                  ...customerAdvanceData,
                  amount: value,
                })
              }}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>Date<span style={{ color: "red" }}>*</span></Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={customerAdvanceData.date}
                onChange={(newValue) =>
                  setCustomerAdvanceData({
                    ...customerAdvanceData,
                    date: newValue,
                  })
                }
                sx={style.calenderInput}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Reference#</InputLabel>
            <TextField
              value={customerAdvanceData.reference}
              onChange={(e) =>
                setCustomerAdvanceData({
                  ...customerAdvanceData,
                  reference: e.target.value,
                })
              }
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={style.inputBoxs}>
            <InputLabel sx={style.label}>Paid Via<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              select
              value={customerAdvanceData.paidVia}
              onChange={(e) =>
                setCustomerAdvanceData({
                  ...customerAdvanceData,
                  paidVia: e.target.value,
                })
              }
              placeholder="Paid Via"
              sx={style.boxs2}
            >
              {paidViaOptions.map((paidVia, idx) => (
                <MenuItem key={idx} value={paidVia.value}>
                  {paidVia.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>TDS<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              select
              value={customerAdvanceData.TDS}
              onChange={(e) =>
                setCustomerAdvanceData({
                  ...customerAdvanceData,
                  TDS: e.target.value,
                })
              }
              placeholder="TDS"
              sx={style.boxs2}
            >
              {TDSOptions.map((tds, idx) => (
                <MenuItem key={idx} value={tds.value}>
                  {tds.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "100%", ml: "5px" }}>
            <InputLabel sx={style.label}>Description</InputLabel>
            <TextField
              multiline
              rows={2}
              value={customerAdvanceData.description}
              onChange={(e) =>
                setCustomerAdvanceData({
                  ...customerAdvanceData,
                  description: e.target.value,
                })
              }
              sx={style.boxs2}
            />
          </Box>
        </Box>
      </Modal>

      {/* Customer Payment Modal */}
      <Modal
        open={openCustomerPaymentModal}
        setOpen={() => {
          resetCustomerPayment();
          setOpenCustomerPaymentModal(false);
        }}
        disabled={
          !customerPaymentData.customer ||
          !customerPaymentData.paidVia ||
          !customerPaymentData.TDS ||
          !customerPaymentData.amount ||
          !customerPaymentData.date
        }
        btnText={"Submit"}
        title={"Customer Payment"}
        handleCheck={handleCustomerPaymentSubmit}
      >
        <Box sx={style.modalGrid}>
        <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Customer<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              select
              value={customerPaymentData.customer}
              onChange={(e) =>
                setCustomerPaymentData({
                  ...customerPaymentData,
                  customer: e.target.value,
                })
              }
              placeholder="Select Customer"
              sx={style.boxs2}
            >
              <MenuItem value="" disabled>
                Select Customer
              </MenuItem>
              {customers.map((customer) => (
                <MenuItem key={customer._id} value={customer._id}>
                  {customer.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Amount<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              type="number"
              value={customerPaymentData.amount}
              onChange={(e) => {
                const value = e.target.value < 0 ? "" : e.target.value;
                setCustomerPaymentData({
                  ...customerPaymentData,
                  amount: value,
                })
              }}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>Date<span style={{ color: "red" }}>*</span></Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={customerPaymentData.date}
                onChange={(newValue) =>
                  setCustomerPaymentData({
                    ...customerPaymentData,
                    date: newValue,
                  })
                }
                sx={style.calenderInput}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Reference#</InputLabel>
            <TextField
              value={customerPaymentData.reference}
              onChange={(e) =>
                setCustomerPaymentData({
                  ...customerPaymentData,
                  reference: e.target.value,
                })
              }
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={style.inputBoxs}>
            <InputLabel sx={style.label}>Paid Via<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              select
              value={customerPaymentData.paidVia}
              onChange={(e) =>
                setCustomerPaymentData({
                  ...customerPaymentData,
                  paidVia: e.target.value,
                })
              }
              placeholder="Paid Via"
              sx={style.boxs2}
            >
              {paidViaOptions.map((paidVia, idx) => (
                <MenuItem key={idx} value={paidVia.value}>
                  {paidVia.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>TDS<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              select
              value={customerPaymentData.TDS}
              onChange={(e) =>
                setCustomerPaymentData({
                  ...customerPaymentData,
                  TDS: e.target.value,
                })
              }
              placeholder="TDS"
              sx={style.boxs2}
            >
              {TDSOptions.map((tds, idx) => (
                <MenuItem key={idx} value={tds.value}>
                  {tds.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "100%", ml: "5px" }}>
            <InputLabel sx={style.label}>Description</InputLabel>
            <TextField
              multiline
              rows={2}
              value={customerPaymentData.description}
              onChange={(e) =>
                setCustomerPaymentData({
                  ...customerPaymentData,
                  description: e.target.value,
                })
              }
              sx={style.boxs2}
            />
          </Box>
        </Box>
      </Modal>

      {/* Transfer From Another Account Modal */}
      <Modal
        open={openTransferFromAccountModal}
        setOpen={() => {
          resetTransferFromAccount();
          setOpenTransferFromAccountModal(false);
        }}
        disabled={
          !transferFromAccountData.fromAccount ||
          !transferFromAccountData.amount
        }
        btnText={"Submit"}
        title={"Transfer From Another Account"}
        handleCheck={handleTransferFromAccountSubmit}
      >
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>From Account</InputLabel>
            <TextField
              select
              value={transferFromAccountData.fromAccount}
              onChange={(e) =>
                setTransferFromAccountData({
                  ...transferFromAccountData,
                  fromAccount: e.target.value,
                })
              }
              sx={style.boxs2}
            >
              {transferFromAccountOptions.map((account, idx) => (
                <MenuItem key={idx} value={account.value}>
                  {account.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Amount</InputLabel>
            <TextField
              type="number"
              value={transferFromAccountData.amount}
              onChange={(e) =>
                setTransferFromAccountData({
                  ...transferFromAccountData,
                  amount: e.target.value,
                })
              }
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>Date</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={transferFromAccountData.date}
                onChange={(newValue) =>
                  setTransferFromAccountData({
                    ...transferFromAccountData,
                    date: newValue,
                  })
                }
                sx={style.calenderInput}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Reference</InputLabel>
            <TextField
              value={transferFromAccountData.reference}
              onChange={(e) =>
                setTransferFromAccountData({
                  ...transferFromAccountData,
                  reference: e.target.value,
                })
              }
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "100%", ml: "5px" }}>
            <InputLabel sx={style.label}>Description</InputLabel>
            <TextField
              multiline
              rows={2}
              value={transferFromAccountData.description}
              onChange={(e) =>
                setTransferFromAccountData({
                  ...transferFromAccountData,
                  description: e.target.value,
                })
              }
              sx={style.boxs2}
            />
          </Box>
        </Box>
      </Modal>

      {/* Interest Income Modal */}
      <Modal
        open={openInterestIncomeModal}
        setOpen={() => {
          resetInterestIncome();
          setOpenInterestIncomeModal(false);
        }}
        disabled={
          !interestIncomeData.amount ||
          !interestIncomeData.paidVia
        }
        btnText={"Submit"}
        title={"Interest Income"}
        handleCheck={handleInterestIncomeSubmit}
      >
        <Box sx={style.modalGrid}>
          <Box sx={style.inputBoxs}>
            <InputLabel sx={style.label}>Paid Via<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              select
              value={interestIncomeData.paidVia}
              onChange={(e) =>
                setInterestIncomeData({
                  ...interestIncomeData,
                  paidVia: e.target.value,
                })
              }
              placeholder="Paid Via"
              sx={style.boxs2}
            >
              {paidViaOptions.map((paidVia, idx) => (
                <MenuItem key={idx} value={paidVia.value}>
                  {paidVia.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Amount<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              type="number"
              value={interestIncomeData.amount}
              onChange={(e) => {
                const value = e.target.value < 0 ? "" : e.target.value;
                setInterestIncomeData({
                  ...interestIncomeData,
                  amount: value,
                })
              }}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>Date<span style={{ color: "red" }}>*</span></Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={interestIncomeData.date}
                onChange={(newValue) =>
                  setInterestIncomeData({
                    ...interestIncomeData,
                    date: newValue,
                  })
                }
                sx={style.calenderInput}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Reference#</InputLabel>
            <TextField
              value={interestIncomeData.reference}
              onChange={(e) =>
                setInterestIncomeData({
                  ...interestIncomeData,
                  reference: e.target.value,
                })
              }
              sx={style.boxs2}
            />
          </Box>
        </Box>
        {/* <Box sx={style.modalGrid}>

        </Box> */}
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "100%", ml: "5px" }}>
            <InputLabel sx={style.label}>Description</InputLabel>
            <TextField
              multiline
              rows={2}
              value={interestIncomeData.description}
              onChange={(e) =>
                setInterestIncomeData({
                  ...interestIncomeData,
                  description: e.target.value,
                })
              }
              sx={style.boxs2}
            />
          </Box>
        </Box>
      </Modal>

      {/* Other Income Modal */}
      <Modal
        open={openOtherIncomeModal}
        setOpen={() => {
          resetOtherIncome();
          setOpenOtherIncomeModal(false);
        }}
        disabled={
          !otherIncomeData.amount ||
          !otherIncomeData.fromAccount
        }
        btnText={"Submit"}
        title={"Other Income"}
        handleCheck={handleOtherIncomeSubmit}
      >
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "50%", ml: "5px" }}>
          <InputLabel sx={style.label}>From Account<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              select
              value={otherIncomeData.fromAccount}
              onChange={(e) =>
                setOtherIncomeData({
                  ...otherIncomeData,
                  fromAccount: e.target.value,
                })
              }
              sx={style.boxs2}
            >
              {otherIncomeFromAccountOptions.map((account, idx) => (
                <MenuItem key={idx} value={account.value}>
                  {account.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Amount<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              type="number"
              value={otherIncomeData.amount}
              onChange={(e) =>
                setOtherIncomeData({
                  ...otherIncomeData,
                  amount: e.target.value,
                })
              }
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>Date<span style={{ color: "red" }}>*</span></Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={otherIncomeData.date}
                onChange={(newValue) =>
                  setOtherIncomeData({
                    ...otherIncomeData,
                    date: newValue,
                  })
                }
                sx={style.calenderInput}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Reference</InputLabel>
            <TextField
              value={otherIncomeData.reference}
              onChange={(e) =>
                setOtherIncomeData({
                  ...otherIncomeData,
                  reference: e.target.value,
                })
              }
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "100%", ml: "5px" }}>
            <InputLabel sx={style.label}>Description</InputLabel>
            <TextField
              multiline
              rows={2}
              value={otherIncomeData.description}
              onChange={(e) =>
                setOtherIncomeData({
                  ...otherIncomeData,
                  description: e.target.value,
                })
              }
              sx={style.boxs2}
            />
          </Box>
        </Box>
      </Modal>

      {/* Expense Refund Modal */}
      <Modal
        open={openExpenseRefundModal}
        setOpen={() => {
          resetExpenseRefund();
          setOpenExpenseRefundModal(false);
        }}
        disabled={
          !expenseRefundData.vendor ||
          !expenseRefundData.amount ||
          !expenseRefundData.fromAccount
        }
        btnText={"Submit"}
        title={"Expense Refund"}
        handleCheck={handleExpenseRefundSubmit}
      >
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "50%", ml: "5px" }}>
          <InputLabel sx={style.label}>Vendor<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              select
              value={expenseRefundData.vendor}
              onChange={(e) =>
                setExpenseRefundData({
                  ...expenseRefundData,
                  vendor: e.target.value,
                })
              }
              placeholder="Select Vendor"
              sx={style.boxs2}
            >
              <MenuItem value="" disabled>
                Select Vendor
              </MenuItem>
              {vendors.map((vendor) => (
                <MenuItem key={vendor._id} value={vendor._id}>
                  {vendor.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Refund Amount<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              type="number"
              value={expenseRefundData.amount}
              onChange={(e) =>
                setExpenseRefundData({
                  ...expenseRefundData,
                  amount: e.target.value,
                })
              }
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>Date<span style={{ color: "red" }}>*</span></Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={expenseRefundData.date}
                onChange={(newValue) =>
                  setExpenseRefundData({
                    ...expenseRefundData,
                    date: newValue,
                  })
                }
                sx={style.calenderInput}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Reference</InputLabel>
            <TextField
              value={expenseRefundData.reference}
              onChange={(e) =>
                setExpenseRefundData({
                  ...expenseRefundData,
                  reference: e.target.value,
                })
              }
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "100%", ml: "5px" }}>
            <InputLabel sx={style.label}>From Account<span style={{ color: "red" }}>*</span></InputLabel>
              <TextField
                select
                value={expenseRefundData.fromAccount}
                onChange={(e) =>
                  setExpenseRefundData({
                    ...expenseRefundData,
                    fromAccount: e.target.value,
                  })
                }
                sx={style.boxs2}
              >
                {expenseRefundFromAccountOptions.map((account, idx) => (
                  <MenuItem key={idx} value={account.value}>
                    {account.label}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "100%", ml: "5px" }}>
            <InputLabel sx={style.label}>Description</InputLabel>
            <TextField
              multiline
              rows={2}
              value={expenseRefundData.description}
              onChange={(e) =>
                setExpenseRefundData({
                  ...expenseRefundData,
                  description: e.target.value,
                })
              }
              sx={style.boxs2}
            />
          </Box>
        </Box>
      </Modal>

      {/* Deposits From Other Accounts Modal */}
      <Modal
        open={openDepositsFromAccountsModal}
        setOpen={() => {
          resetDepositsFromAccounts();
          setOpenDepositsFromAccountsModal(false);
        }}
        disabled={
          !depositsFromAccountsData.fromAccount ||
          !depositsFromAccountsData.amount
        }
        btnText={"Submit"}
        title={"Deposits From Other Accounts"}
        handleCheck={handleDepositsFromAccountsSubmit}
      >
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>From Account</InputLabel>
            <TextField
              select
              value={depositsFromAccountsData.fromAccount}
              onChange={(e) => setDepositsFromAccountsData({
                ...depositsFromAccountsData,
                fromAccount: e.target.value
              })}
              sx={style.boxs2}
            >
              {depositsFromOtherFromAccountOptions.map((account, idx) => (
                <MenuItem key={idx} value={account.value}>
                  {account.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Amount</InputLabel>
            <TextField
              type="number"
              value={depositsFromAccountsData.amount}
              onChange={(e) => setDepositsFromAccountsData({
                ...depositsFromAccountsData,
                amount: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{...style.inputBoxs, width: "50%", ml: "5px" }}>
            <Typography sx={style.inputTexts}>Date</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={depositsFromAccountsData.date}
                onChange={(newValue) => setDepositsFromAccountsData({
                  ...depositsFromAccountsData,
                  date: newValue
                })}
                sx={style.calenderInput}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Reference</InputLabel>
            <TextField
              value={depositsFromAccountsData.reference}
              onChange={(e) => setDepositsFromAccountsData({
                ...depositsFromAccountsData,
                reference: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "100%", ml: "5px" }}>
            <InputLabel sx={style.label}>Description</InputLabel>
            <TextField
              multiline
              rows={2}
              value={depositsFromAccountsData.description}
              onChange={(e) => setDepositsFromAccountsData({
                ...depositsFromAccountsData,
                description: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
      </Modal>

      {/* Owner's Contribution Modal */}
      <Modal
        open={openOwnersContributionModal}
        setOpen={() => {
          resetOwnersContribution();
          setOpenOwnersContributionModal(false);
        }}
        disabled={
          !ownersContributionData.fromAccount ||
          !ownersContributionData.amount
        }
        btnText={"Submit"}
        title={"Owner's Contribution"}
        handleCheck={handleOwnersContributionSubmit}
      >
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>From Account</InputLabel>
            <TextField
              select
              value={ownersContributionData.fromAccount}
              onChange={(e) => setOwnersContributionData({
                ...ownersContributionData,
                fromAccount: e.target.value
              })}
              sx={style.boxs2}
            >
              {ownersContributionFromAccountOptions.map((account, idx) => (
                <MenuItem key={idx} value={account.value}>
                  {account.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Amount</InputLabel>
            <TextField
              type="number"
              value={ownersContributionData.amount}
              onChange={(e) => setOwnersContributionData({
                ...ownersContributionData,
                amount: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{width: "50%", ml: "5px"}}>
            <Typography sx={style.inputTexts}>Date</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={ownersContributionData.date}
                onChange={(newValue) => setOwnersContributionData({
                  ...ownersContributionData,
                  date: newValue
                })}
                sx={style.calenderInput}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Reference</InputLabel>
            <TextField
              value={ownersContributionData.reference}
              onChange={(e) => setOwnersContributionData({
                ...ownersContributionData,
                reference: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          
          <Box sx={{ width: "100%", ml: "5px" }}>
            <InputLabel sx={style.label}>Description</InputLabel>
            <TextField
              multiline
              rows={2}
              value={ownersContributionData.description}
              onChange={(e) => setOwnersContributionData({
                ...ownersContributionData,
                description: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
      </Modal>

      {/* Vendor Credit Refund Modal */}
      <Modal
        open={openVendorCreditRefundModal}
        setOpen={() => {
          resetVendorCreditRefund();
          setOpenVendorCreditRefundModal(false);
        }}
        disabled={
          !vendorCreditRefundData.vendor ||
          !vendorCreditRefundData.amount
        }
        btnText={"Submit"}
        title={"Vendor Credit Refund"}
        handleCheck={handleVendorCreditRefundSubmit}
      >
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Vendor<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              select
              value={vendorCreditRefundData.vendor}
              onChange={(e) => setVendorCreditRefundData({
                ...vendorCreditRefundData,
                vendor: e.target.value
              })}
              sx={style.boxs2}
            >
              <MenuItem value="" disabled>Select Vendor</MenuItem>
              {vendors.map((vendor) => (
                <MenuItem key={vendor._id} value={vendor._id}>
                  {vendor.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Refund Amount<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              type="number"
              value={vendorCreditRefundData.amount}
              onChange={(e) => setVendorCreditRefundData({
                ...vendorCreditRefundData,
                amount: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>Date<span style={{ color: "red" }}>*</span></Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={vendorCreditRefundData.date}
                onChange={(newValue) => setVendorCreditRefundData({
                  ...vendorCreditRefundData,
                  date: newValue
                })}
                sx={style.calenderInput}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Reference</InputLabel>
            <TextField
              value={vendorCreditRefundData.reference}
              onChange={(e) => setVendorCreditRefundData({
                ...vendorCreditRefundData,
                reference: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "100%", ml: "5px" }}>
            <InputLabel sx={style.label}>Description</InputLabel>
            <TextField
              multiline
              rows={2}
              value={vendorCreditRefundData.description}
              onChange={(e) => setVendorCreditRefundData({
                ...vendorCreditRefundData,
                description: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
      </Modal>

      {/* Vendor Payment Refund Modal */}
      <Modal
        open={openVendorPaymentRefundModal}
        setOpen={() => {
          resetVendorPaymentRefund();
          setOpenVendorPaymentRefundModal(false);
        }}
        disabled={
          !vendorPaymentRefundData.vendor ||
          !vendorPaymentRefundData.amount
        }
        btnText={"Submit"}
        title={"Vendor Payment Refund"}
        handleCheck={handleVendorPaymentRefundSubmit}
      >
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Vendor<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              select
              value={vendorPaymentRefundData.vendor}
              onChange={(e) => setVendorPaymentRefundData({
                ...vendorPaymentRefundData,
                vendor: e.target.value
              })}
              sx={style.boxs2}
            >
              <MenuItem value="" disabled>Select Vendor</MenuItem>
              {vendors.map((vendor) => (
                <MenuItem key={vendor._id} value={vendor._id}>
                  {vendor.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Refund Amount<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              type="number"
              value={vendorPaymentRefundData.amount}
              onChange={(e) => setVendorPaymentRefundData({
                ...vendorPaymentRefundData,
                amount: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>Date<span style={{ color: "red" }}>*</span></Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={vendorPaymentRefundData.date}
                onChange={(newValue) => setVendorPaymentRefundData({
                  ...vendorPaymentRefundData,
                  date: newValue
                })}
                sx={style.calenderInput}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Reference</InputLabel>
            <TextField
              value={vendorPaymentRefundData.reference}
              onChange={(e) => setVendorPaymentRefundData({
                ...vendorPaymentRefundData,
                reference: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "100%", ml: "5px" }}>
            <InputLabel sx={style.label}>Description</InputLabel>
            <TextField
              multiline
              rows={2}
              value={vendorPaymentRefundData.description}
              onChange={(e) => setVendorPaymentRefundData({
                ...vendorPaymentRefundData,
                description: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
      </Modal>

      {/* Expense Modal */}
      <Modal
        open={openExpenseModal}
        setOpen={() => {
          resetExpense();
          setOpenExpenseModal(false);
        }}
        disabled={
          !expenseData.toAccount ||
          !expenseData.amount
        }
        btnText={"Submit"}
        title={"Expense"}
        handleCheck={handleExpenseSubmit}
      >
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Vendor</InputLabel>
            <TextField
              select
              value={expenseData.vendor}
              onChange={(e) => setExpenseData({
                ...expenseData,
                vendor: e.target.value
              })}
              sx={style.boxs2}
            >
              <MenuItem value="" disabled>Select Vendor</MenuItem>
              {vendors.map((vendor) => (
                <MenuItem key={vendor._id} value={vendor._id}>
                  {vendor.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Customer</InputLabel>
            <TextField
              select
              value={expenseData.customer}
              onChange={(e) =>
                setExpenseData({
                  ...expenseData,
                  customer: e.target.value,
                })
              }
              placeholder="Select Customer"
              sx={style.boxs2}
            >
              <MenuItem value="" disabled>
                Select Customer
              </MenuItem>
              {customers.map((customer) => (
                <MenuItem key={customer._id} value={customer._id}>
                  {customer.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Amount<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              type="number"
              value={expenseData.amount}
              onChange={(e) => setExpenseData({
                ...expenseData,
                amount: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
          <InputLabel sx={style.label}>Expense Account<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              select
              value={expenseData.toAccount}
              onChange={(e) =>
                setExpenseData({
                  ...expenseData,
                  toAccount: e.target.value,
                })
              }
              sx={style.boxs2}
            >
              {expenseAccountOptions.map((account, idx) => (
                <MenuItem key={idx} value={account.value}>
                  {account.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
        <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>Date</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={expenseData.date}
                onChange={(newValue) => setExpenseData({
                  ...expenseData,
                  date: newValue
                })}
                sx={style.calenderInput}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Reference</InputLabel>
            <TextField
              value={expenseData.reference}
              onChange={(e) => setExpenseData({
                ...expenseData,
                reference: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "100%", ml: "5px" }}>
            <InputLabel sx={style.label}>Description</InputLabel>
            <TextField
              multiline
              rows={2}
              value={expenseData.description}
              onChange={(e) => setExpenseData({
                ...expenseData,
                description: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
      </Modal>

      {/* Vendor Advance Modal */}
      <Modal
        open={openVendorAdvanceModal}
        setOpen={() => {
          resetVendorAdvance();
          setOpenVendorAdvanceModal(false);
        }}
        disabled={
          !vendorAdvanceData.vendor ||
          !vendorAdvanceData.amount
        }
        btnText={"Submit"}
        title={"Vendor Advance"}
        handleCheck={handleVendorAdvanceSubmit}
      >
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Vendor<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              select
              value={vendorAdvanceData.vendor}
              onChange={(e) => setVendorAdvanceData({
                ...vendorAdvanceData,
                vendor: e.target.value
              })}
              sx={style.boxs2}
            >
              <MenuItem value="" disabled>Select Vendor</MenuItem>
              {vendors.map((vendor) => (
                <MenuItem key={vendor._id} value={vendor._id}>
                  {vendor.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Advance Amount<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              type="number"
              value={vendorAdvanceData.amount}
              onChange={(e) => setVendorAdvanceData({
                ...vendorAdvanceData,
                amount: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>Date<span style={{ color: "red" }}>*</span></Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={vendorAdvanceData.date}
                onChange={(newValue) => setVendorAdvanceData({
                  ...vendorAdvanceData,
                  date: newValue
                })}
                sx={style.calenderInput}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Reference</InputLabel>
            <TextField
              value={vendorAdvanceData.reference}
              onChange={(e) => setVendorAdvanceData({
                ...vendorAdvanceData,
                reference: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "100%", ml: "5px" }}>
            <InputLabel sx={style.label}>Description</InputLabel>
            <TextField
              multiline
              rows={2}
              value={vendorAdvanceData.description}
              onChange={(e) => setVendorAdvanceData({
                ...vendorAdvanceData,
                description: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
      </Modal>

      {/* Vendor Payment Modal */}
      <Modal
        open={openVendorPaymentModal}
        setOpen={() => {
          resetVendorPayment();
          setOpenVendorPaymentModal(false);
        }}
        disabled={
          !vendorPaymentData.vendor ||
          !vendorPaymentData.amount ||
          !vendorPaymentData.paidVia ||
          !vendorPaymentData.TDS
        }
        btnText={"Submit"}
        title={"Vendor Payment"}
        handleCheck={handleVendorPaymentSubmit}
      >
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Vendor<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              select
              value={vendorPaymentData.vendor}
              onChange={(e) => setVendorPaymentData({
                ...vendorPaymentData,
                vendor: e.target.value
              })}
              sx={style.boxs2}
            >
              <MenuItem value="" disabled>Select Vendor</MenuItem>
              {vendors.map((vendor) => (
                <MenuItem key={vendor._id} value={vendor._id}>
                  {vendor.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Paid Via<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              select
              value={vendorPaymentData.paidVia}
              onChange={(e) => setVendorPaymentData({
                ...vendorPaymentData,
                paidVia: e.target.value
              })}
              sx={style.boxs2}
            >
              {paidViaOptions.map((paidVia, idx) => (
                <MenuItem key={idx} value={paidVia.value}>
                  {paidVia.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Amount<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              type="number"
              value={vendorPaymentData.amount}
              onChange={(e) => setVendorPaymentData({
                ...vendorPaymentData,
                amount: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>TDS<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              select
              value={vendorPaymentData.TDS}
              onChange={(e) =>
                setVendorPaymentData({
                  ...vendorPaymentData,
                  TDS: e.target.value,
                })
              }
              placeholder="TDS"
              sx={style.boxs2}
            >
              {TDSOptions.map((tds, idx) => (
                <MenuItem key={idx} value={tds.value}>
                  {tds.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>Date<span style={{ color: "red" }}>*</span></Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={vendorPaymentData.date}
                onChange={(newValue) => setVendorPaymentData({
                  ...vendorPaymentData,
                  date: newValue
                })}
                sx={style.calenderInput}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Reference</InputLabel>
            <TextField
              value={vendorPaymentData.reference}
              onChange={(e) => setVendorPaymentData({
                ...vendorPaymentData,
                reference: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "100%", ml: "5px" }}>
            <InputLabel sx={style.label}>Description</InputLabel>
            <TextField
              multiline
              rows={2}
              value={vendorPaymentData.description}
              onChange={(e) =>
                setVendorPaymentData({
                  ...vendorPaymentData,
                  description: e.target.value,
                })
              }
              sx={style.boxs2}
            />
          </Box>
        </Box>
      </Modal>

      {/* Transfer To Another Account Modal */}
      <Modal
        open={openTransferToAccountModal}
        setOpen={() => {
          resetTransferToAccount();
          setOpenTransferToAccountModal(false);
        }}
        disabled={
          !transferToAccountData.toAccount ||
          !transferToAccountData.amount ||
          !transferToAccountData.date
        }
        btnText={"Submit"}
        title={"Transfer To Another Account"}
        handleCheck={handleTransferToAccountSubmit}
      >
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>To Account<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              select
              value={transferToAccountData.toAccount}
              onChange={(e) => setTransferToAccountData({
                ...transferToAccountData,
                toAccount: e.target.value
              })}
              sx={style.boxs2}
            >
              {transferToAccountOptions.map((account, idx) => (
                <MenuItem key={idx} value={account.value}>
                  {account.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Amount<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              type="number"
              value={transferToAccountData.amount}
              onChange={(e) => setTransferToAccountData({
                ...transferToAccountData,
                amount: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>Date<span style={{ color: "red" }}>*</span></Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={transferToAccountData.date}
                onChange={(newValue) => setTransferToAccountData({
                  ...transferToAccountData,
                  date: newValue
                })}
                sx={style.calenderInput}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Reference</InputLabel>
            <TextField
              value={transferToAccountData.reference}
              onChange={(e) => setTransferToAccountData({
                ...transferToAccountData,
                reference: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "100%", ml: "5px" }}>
            <InputLabel sx={style.label}>Description</InputLabel>
            <TextField
              multiline
              rows={2}
              value={transferToAccountData.description}
              onChange={(e) => setTransferToAccountData({
                ...transferToAccountData,
                description: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
      </Modal>

      {/* Owner Drawings Modal */}
      <Modal
        open={openOwnerDrawingsModal}
        setOpen={() => {
          resetOwnerDrawings();
          setOpenOwnerDrawingsModal(false);
        }}
        disabled={
          !ownerDrawingsData.amount ||
          !ownerDrawingsData.toAccount ||
          !ownerDrawingsData.date
        }
        btnText={"Submit"}
        title={"Owner Drawings"}
        handleCheck={handleOwnerDrawingsSubmit}
      >
        <Box sx={style.modalGrid}>
        <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>To Account<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              select
              value={ownerDrawingsData.toAccount}
              onChange={(e) => setOwnerDrawingsData({
                ...ownerDrawingsData,
                toAccount: e.target.value
              })}
              sx={style.boxs2}
            >
              {ownersDrawingToAccountOptions.map((account, idx) => (
                <MenuItem key={idx} value={account.value}>
                  {account.label}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Amount<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              type="number"
              value={ownerDrawingsData.amount}
              onChange={(e) => setOwnerDrawingsData({
                ...ownerDrawingsData,
                amount: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>Date<span style={{ color: "red" }}>*</span></Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={ownerDrawingsData.date}
                onChange={(newValue) => setOwnerDrawingsData({
                  ...ownerDrawingsData,
                  date: newValue
                })}
                sx={style.calenderInput}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Reference</InputLabel>
            <TextField
              value={ownerDrawingsData.reference}
              onChange={(e) => setOwnerDrawingsData({
                ...ownerDrawingsData,
                reference: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "100%", ml: "5px" }}>
            <InputLabel sx={style.label}>Description</InputLabel>
            <TextField
              multiline
              rows={2}
              value={ownerDrawingsData.description}
              onChange={(e) => setOwnerDrawingsData({
                ...ownerDrawingsData,
                description: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
      </Modal>

      {/* Credit Note Refund Modal */}
      <Modal
        open={openCreditNoteRefundModal}
        setOpen={() => {
          resetCreditNoteRefund();
          setOpenCreditNoteRefundModal(false);
        }}
        disabled={
          !creditNoteRefundData.customer ||
          !creditNoteRefundData.amount ||
          !creditNoteRefundData.date
        }
        btnText={"Submit"}
        title={"Credit Note Refund"}
        handleCheck={handleCreditNoteRefundSubmit}
      >
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Customer</InputLabel>
            <TextField
              select
              value={creditNoteRefundData.customer}
              onChange={(e) => setCreditNoteRefundData({
                ...creditNoteRefundData,
                customer: e.target.value
              })}
              sx={style.boxs2}
            >
              <MenuItem value="" disabled>Select Customer</MenuItem>
              {customers.map((customer) => (
                <MenuItem key={customer._id} value={customer._id}>
                  {customer.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Refund Amount</InputLabel>
            <TextField
              type="number"
              value={creditNoteRefundData.amount}
              onChange={(e) => setCreditNoteRefundData({
                ...creditNoteRefundData,
                amount: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>Date</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={creditNoteRefundData.date}
                onChange={(newValue) => setCreditNoteRefundData({
                  ...creditNoteRefundData,
                  date: newValue
                })}
                sx={style.calenderInput}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Reference</InputLabel>
            <TextField
              value={creditNoteRefundData.reference}
              onChange={(e) => setCreditNoteRefundData({
                ...creditNoteRefundData,
                reference: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "100%", ml: "5px" }}>
            <InputLabel sx={style.label}>Description</InputLabel>
            <TextField
              multiline
              rows={2}
              value={creditNoteRefundData.description}
              onChange={(e) => setCreditNoteRefundData({
                ...creditNoteRefundData,
                description: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
      </Modal>

      {/* Payment Refund Modal */}
      <Modal
        open={openPaymentRefundModal}
        setOpen={() => {
          resetPaymentRefund();
          setOpenPaymentRefundModal(false);
        }}
        disabled={
          !paymentRefundData.customer ||
          !paymentRefundData.amount ||
          !paymentRefundData.date
        }
        btnText={"Submit"}
        title={"Payment Refund"}
        handleCheck={handlePaymentRefundSubmit}
      >
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Customer</InputLabel>
            <TextField
              select
              value={paymentRefundData.customer}
              onChange={(e) => setPaymentRefundData({
                ...paymentRefundData,
                customer: e.target.value
              })}
              sx={style.boxs2}
            >
              <MenuItem value="" disabled>Select Customer</MenuItem>
              {customers.map((customer) => (
                <MenuItem key={customer._id} value={customer._id}>
                  {customer.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Refund Amount</InputLabel>
            <TextField
              type="number"
              value={paymentRefundData.amount}
              onChange={(e) => setPaymentRefundData({
                ...paymentRefundData,
                amount: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={style.inputBoxs}>
            <Typography sx={style.inputTexts}>Date</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={paymentRefundData.date}
                onChange={(newValue) => setPaymentRefundData({
                  ...paymentRefundData,
                  date: newValue
                })}
                sx={style.calenderInput}
              />
            </LocalizationProvider>
          </Box>
          <Box sx={{ width: "50%", ml: "5px" }}>
            <InputLabel sx={style.label}>Reference</InputLabel>
            <TextField
              value={paymentRefundData.reference}
              onChange={(e) => setPaymentRefundData({
                ...paymentRefundData,
                reference: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
        <Box sx={style.modalGrid}>
          <Box sx={{ width: "100%", ml: "5px" }}>
            <InputLabel sx={style.label}>Description</InputLabel>
            <TextField
              multiline
              rows={2}
              value={paymentRefundData.description}
              onChange={(e) => setPaymentRefundData({
                ...paymentRefundData,
                description: e.target.value
              })}
              sx={style.boxs2}
            />
          </Box>
        </Box>
      </Modal>

      <Popover
        open={moneyInOptionsPopover}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2, pr: 6 }}>
          <Box>
            <Box
              sx={style.iconGrid}
              onClick={() => {
                handleOpenPopup("customerAdvance");
              }}
            >
              <Box sx={style.iconText}>Customer Advance</Box>
            </Box>
          </Box>
          <Box>
            <Box
              sx={style.iconGrid}
              onClick={() => {
                handleOpenPopup("customerPayment");
              }}
            >
              <Box sx={style.iconText}>Customer Payment</Box>
            </Box>
          </Box>
          <Box>
            <Box
              sx={style.iconGrid}
              onClick={() => {
                handleOpenPopup("transferFromAnotherAccount");
              }}
            >
              <Box sx={style.iconText}>Transfer from Another Account</Box>
            </Box>
          </Box>
          <Box>
            <Box
              sx={style.iconGrid}
              onClick={() => {
                handleOpenPopup("interestIncome");
              }}
            >
              <Box sx={style.iconText}>Interest Income</Box>
            </Box>
          </Box>
          <Box>
            <Box
              sx={style.iconGrid}
              onClick={() => {
                handleOpenPopup("otherIncome");
              }}
            >
              <Box sx={style.iconText}>Other Income</Box>
            </Box>
          </Box>
          <Box>
            <Box
              sx={style.iconGrid}
              onClick={() => {
                handleOpenPopup("expenseRefund");
              }}
            >
              <Box sx={style.iconText}>Expense Refund</Box>
            </Box>
          </Box>
          <Box>
            <Box
              sx={style.iconGrid}
              onClick={() => {
                handleOpenPopup("depositsFromOtherAccounts");
              }}
            >
              <Box sx={style.iconText}>Deposits from Other Accounts</Box>
            </Box>
          </Box>
          <Box>
            <Box
              sx={style.iconGrid}
              onClick={() => {
                handleOpenPopup("ownersContribution");
              }}
            >
              <Box sx={style.iconText}>{"Owner's Contribution"}</Box>
            </Box>
          </Box>
          <Box>
            <Box
              sx={style.iconGrid}
              onClick={() => {
                handleOpenPopup("vendorCreditRefund");
              }}
            >
              <Box sx={style.iconText}>Vendor Credit Refund</Box>
            </Box>
          </Box>
          <Box>
            <Box
              sx={style.iconGrid}
              onClick={() => {
                handleOpenPopup("vendorPaymentRefund");
              }}
            >
              <Box sx={style.iconText}>Vendor Payment Refund</Box>
            </Box>
          </Box>
        </Box>
      </Popover>

      <Popover
        open={moneyOutOptionsPopover}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <Box sx={{ p: 2, pr: 6 }}>
          <Box>
            <Box
              sx={style.iconGrid}
              onClick={() => {
                handleOpenPopup("expense");
              }}
            >
              <Box sx={style.iconText}>Expense</Box>
            </Box>
          </Box>
          <Box>
            <Box
              sx={style.iconGrid}
              onClick={() => {
                handleOpenPopup("vendorAdvance");
              }}
            >
              <Box sx={style.iconText}>Vendor Advance</Box>
            </Box>
          </Box>
          <Box>
            <Box
              sx={style.iconGrid}
              onClick={() => {
                handleOpenPopup("vendorPayment");
              }}
            >
              <Box sx={style.iconText}>Vendor Payment</Box>
            </Box>
          </Box>
          <Box>
            <Box
              sx={style.iconGrid}
              onClick={() => {
                handleOpenPopup("transferToAnotherAccount");
              }}
            >
              <Box sx={style.iconText}>Transfer to Another Account</Box>
            </Box>
          </Box>
          <Box>
            <Box
              sx={style.iconGrid}
              onClick={() => {
                handleOpenPopup("ownerDrawings");
              }}
            >
              <Box sx={style.iconText}>Owner Drawings</Box>
            </Box>
          </Box>
          <Box>
            <Box
              sx={style.iconGrid}
              onClick={() => {
                handleOpenPopup("creditNoteRefund");
              }}
            >
              <Box sx={style.iconText}>Credit Note Refund</Box>
            </Box>
          </Box>
          <Box>
            <Box
              sx={style.iconGrid}
              onClick={() => {
                handleOpenPopup("paymentRefund");
              }}
            >
              <Box sx={style.iconText}>Payment Refund</Box>
            </Box>
          </Box>
        </Box>
      </Popover>
    </>
  );
}

export default AccountTransactionPage;
